var _g, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRow22(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1322_38430)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 8,
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.199 30.3608C47.199 27.4013 45.36 24.844 42.6303 23.8384C42.7459 23.2128 42.8036 22.578 42.8026 21.9418C42.8026 16.4536 38.3489 12 32.8608 12C29.6713 12 26.683 13.5229 24.8153 16.1376C23.8958 15.4192 22.7752 15.0457 21.5971 15.0457C18.6949 15.0457 16.3101 17.4018 16.3101 20.3328C16.3101 20.9649 16.425 21.5971 16.6261 22.1718C13.8678 23.12 12 25.7635 12 28.6942C12 31.6539 13.839 34.2399 16.5974 35.2456C16.4825 35.849 16.425 36.4812 16.425 37.142C16.425 42.6014 20.8787 47.0552 26.3381 47.0552C29.5563 47.0552 32.516 45.5036 34.3836 42.9176C35.3031 43.6358 36.4524 44.0382 37.6306 44.0382C40.5327 44.0382 42.9176 41.682 42.9176 38.7512C42.9176 38.119 42.8026 37.4869 42.6015 36.9122C45.3024 35.9352 47.1989 33.2917 47.1989 30.3608H47.199Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7631 27.0563L33.6075 30.6481L41.538 23.6946C41.6537 23.1175 41.7114 22.5303 41.7104 21.9418C41.7104 17.0571 37.7452 13.0918 32.8604 13.0918C29.9295 13.0918 27.1999 14.5284 25.5621 16.942L24.2402 23.7808L25.7631 27.0563Z",
    fill: "#F4BD19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6323 35.3593C17.5174 35.934 17.46 36.5374 17.46 37.1408C17.46 42.0255 21.4539 46.0195 26.3387 46.0195C29.2983 46.0195 32.028 44.5541 33.6945 42.1404L34.9876 35.3018L34.1112 33.6352L33.2348 31.9686L25.3617 28.377L17.6323 35.3593Z",
    fill: "#3CBEB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5731 21.7707L22.9464 23.0351L24.1531 16.9147C23.4061 16.34 22.5152 16.0527 21.5671 16.0527C19.2396 16.0527 17.3145 17.9491 17.3145 20.3053C17.3145 20.7938 17.4008 21.311 17.5731 21.7707Z",
    fill: "#E9478C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1153 23.0625C14.7017 23.8384 13.0352 26.1659 13.0352 28.6944C13.0352 31.1656 14.558 33.3781 16.8568 34.2401L24.4138 27.4013L23.0345 24.4419L17.1153 23.0625Z",
    fill: "#2C458F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0732 42.113C35.8202 42.6878 36.7111 43.0038 37.6305 43.0038C39.958 43.0038 41.8831 41.1074 41.8831 38.7512C41.8831 38.234 41.7969 37.7454 41.6246 37.2857L36.2514 36.0215L35.0732 42.113Z",
    fill: "#95C63D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1653 34.6126L42.0845 35.9919C44.4981 35.1874 46.1646 32.8887 46.1646 30.36C46.1646 27.8888 44.6418 25.7052 42.343 24.8145L34.585 31.5956L36.1653 34.6126Z",
    fill: "#176655"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 59,
    height: 59,
    rx: 7.5,
    stroke: "white",
    strokeOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1322_38430"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 8,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRow22);
export default __webpack_public_path__ + "static/media/row-2-2.216b281df6d0e4d840e51ddad6510901.svg";
export { ForwardRef as ReactComponent };